import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addMessage } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';

const useAddMessage = () => {
    const entityUpdater = useEntityQueryUpdate();
    const queryClient = useQueryClient();

    const addMessageMutation = useMutation({
        mutationKey: 'add_message',
        mutationFn: (model) => addMessage(model),
        onSuccess: (data) => {
            entityUpdater(
                [['campaign_messages'], ['campaign_message', data.id]],
                data
            );
            queryClient.invalidateQueries({
                queryKey: ['message_group', data.groupId],
                exact: true,
            });
            notifications.show({
                title: 'Success',
                message: 'Successfully updated message',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return addMessageMutation;
};
export default useAddMessage;
